import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { UntilDestroy } from '@ngneat/until-destroy';

import { VoiceResponseCommandName } from '@pwp-common';

import { provideValueAccessor } from '../../../../common/form/provide-value-accessor';
import { FormGroupControlValueAccessor } from '../../../generic/abstract-classes/form-group-control-value-accessor';

@UntilDestroy()
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-service-command-name-select',
  templateUrl: './service-command-name-select.component.html',
  styleUrls: ['./service-command-name-select.component.css'],
  providers: [provideValueAccessor(() => ServiceCommandNameSelectComponent)],
})
export class ServiceCommandNameSelectComponent
  extends FormGroupControlValueAccessor<any, any>
  implements OnChanges, OnInit
{
  /////////////////////////////////////////////////////////////////////////////////////////////
  // Inputs
  /////////////////////////////////////////////////////////////////////////////////////////////

  @Input() public excludedCommands?: VoiceResponseCommandName[];

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Constants
  /////////////////////////////////////////////////////////////////////////////////////////////

  public readonly allCommands = [
    VoiceResponseCommandName.autoAcceptCall,
    VoiceResponseCommandName.dialCallList,
    VoiceResponseCommandName.execIVR,
    VoiceResponseCommandName.enforceServiceLimit,
    VoiceResponseCommandName.flagServiceRequest,
    VoiceResponseCommandName.forward,
    VoiceResponseCommandName.playOrSay,
    VoiceResponseCommandName.takeVoicemail,
    VoiceResponseCommandName.createAsyncServiceRequest,
  ];

  public commands = [];

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Lifecycle
  /////////////////////////////////////////////////////////////////////////////////////////////

  constructor(public changeDetectorRef: ChangeDetectorRef) {
    super(changeDetectorRef);
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Lifecycle Hooks
  /////////////////////////////////////////////////////////////////////////////////////////////

  public ngOnInit(): void {
    super.ngOnInit();
    this.updateCommands();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if ('excludedCommands' in changes) {
      this.updateCommands();
    }
  }
  /////////////////////////////////////////////////////////////////////////////////////////////
  // Define Form
  /////////////////////////////////////////////////////////////////////////////////////////////

  public defineForm() {
    this.form = new UntypedFormGroup({
      commandName: new UntypedFormControl(),
    });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Write Value
  /////////////////////////////////////////////////////////////////////////////////////////////

  public writeValue(value: string) {
    const patchedValue = { commandName: value };
    this.form.setValue(patchedValue, { emitEvent: false });
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Parse Value Change
  /////////////////////////////////////////////////////////////////////////////////////////////

  // eslint-disable-next-line class-methods-use-this
  public parseValueChange(value: any): any {
    return value.commandName;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Form Controls
  /////////////////////////////////////////////////////////////////////////////////////////////

  public get commandName() {
    return this.form.get('commandName') as UntypedFormControl;
  }

  /////////////////////////////////////////////////////////////////////////////////////////////
  // Public Methods
  /////////////////////////////////////////////////////////////////////////////////////////////

  private updateCommands(): void {
    this.commands = this.allCommands
      .filter((command) => !this.excludedCommands?.includes(command))
      .map((command) => ({ label: command, value: command }));
  }
}
